import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { getPluralFormForHandlingUnitType } from "@/Data/getPluralFormForHandlingUnitType";
import { getPrepositionForHandlingUnitType } from "@/Data/getPrepositionForHandlingUnitType";
import { getSingularFormForHandlingUnitType } from "@/Data/getSingularFormForHandlingUnitType";

/**
 * The heading above the description field, phrased around whatever the freight
 * is packed in — "What is on this pallet?", "What are in these boxes?".
 *
 * The preposition varies with the handling unit (on a pallet, in a box), which
 * is why it comes from a lookup rather than being hardcoded. Falls back to the
 * neutral wording when the type is unset or Other, since there is no sensible
 * noun to point at.
 */
export function lineItemsLabelForContentsSection(
  handlingUnitType: HandlingUnitType | undefined,
  multipleHandlingUnits: boolean,
): string {
  if (
    handlingUnitType === undefined ||
    handlingUnitType === HandlingUnitType.Other
  ) {
    return `What are the contents?`;
  }

  const preposition = getPrepositionForHandlingUnitType(handlingUnitType);

  if (!multipleHandlingUnits) {
    const singular =
      getSingularFormForHandlingUnitType(handlingUnitType).toLowerCase();
    return `What is ${preposition} this ${singular}?`;
  }

  const plural = getPluralFormForHandlingUnitType(handlingUnitType);
  return `What are ${preposition} these ${plural.toLowerCase()}?`;
}

/**
 * The heading above the dimensions row. Dimensions are always per handling
 * unit, never for the shipment as a whole, so the label names the unit to make
 * that unambiguous.
 */
export function lineItemsLabelForDimensionsSection(
  handlingUnitType: HandlingUnitType | undefined,
): string {
  if (
    handlingUnitType === undefined ||
    handlingUnitType === HandlingUnitType.Other
  ) {
    return `What are the dimensions?`;
  }

  return `What are the dimensions for each ${handlingUnitType
    .toString()
    .toLowerCase()}?`;
}
